import { processRawInput } from "./processRawInput";
import ItemPlugin from "./ShoppingItem/ShoppingItem";
import { userShare } from "./userShare";

export default function registerShoppingPlugin() {
  return { ItemPlugin, userShare, processRawInput };
}
